var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSidebarHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1699 4.24121C11.6434 3.82073 12.3566 3.82073 12.8301 4.24121L19.4951 10.165C19.9755 10.592 20.25 11.205 20.25 11.8477V18.5C20.25 19.1904 19.6904 19.75 19 19.75H5C4.30964 19.75 3.75 19.1904 3.75 18.5V11.8477C3.75 11.205 4.02453 10.592 4.50488 10.165L11.1699 4.24121Z",
    stroke: "#0D0E11",
    strokeOpacity: 0.29,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSidebarHome);
export default __webpack_public_path__ + "static/media/ico_sidebar_home.57cfb5f9e55d04a39c00ce668f511076.svg";
export { ForwardRef as ReactComponent };